<template>
    <div class="BeltSection">
        <div class="currentBeltContainer">
            <Belt class="beltIcon" v-bind="beltProps" />
        </div>
        <div v-if="belt.next" class="divider" />
        <div class="nextBeltProgressContainer">
            <div v-if="belt.next" class="lifekeys">
                <template v-for="i of belt.next.requiredPoints">
                    <div v-if="i > 1" :key="'gap' + i" class="lifekeysGap" />
                    <Lifekey :key="i" :completed="i <= belt.points" :class="{ completed: i <= belt.points }" />
                </template>
            </div>
            <div class="textContainer">
                <div v-if="belt.current" class="beltName">
                    <span class="beltGrade">{{ $t(`belts.beltGrades.${belt.current.id}`) }}</span>
                    {{ $t('belt') }} {{ belt.current.number || '' }}
                </div>
                <div v-else class="beltName beltName--noBelt">
                    {{ $t('noBelt') }}
                </div>

                <NextBeltProgressText v-if="belt.next" class="nextBeltProgress" :belt="belt" />
            </div>
        </div>
    </div>
</template>

<translations>
  belt: 'belt'
  belt_no: 'belte'
  noBelt: ' '
  noBelt_no: ' '
  # progressText: '{count} life key left for the next belt | {count} life keys left for the next belt'
  # progressText_no: '{count} livsnøkkel igjen til neste belte | {count} livsnøkler igjen til neste belte'

  # firstBeltProgressText: '{count} life key for your first belt | {count} life keys for your first belt'
  # firstBeltProgressText_no: '{count} livsnøkkel til ditt første belte | {count} livsnøkler til ditt første belte'

  viewLeaderboard: 'View leaderboard'
  yourRank: 'Your Rank'
</translations>

<script>
import Belt from './Belt';
import Lifekey from './Lifekey';
import NextBeltProgressText from './NextBeltProgressText';

export default {
    components: { Belt, Lifekey, NextBeltProgressText },
    computed: {
        belt() {
            return this.$store.getters['moduleApp/belt'];
        },
        beltProps() {
            if (!this.belt.current) {
                return null;
            }
            return {
                color: this.belt.current.color,
                avatar: this.$store.getters['moduleAuth/avatar']
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.BeltSection {
    display: flex;
    align-items: center;
}

.beltIcon {
    $size: 4em;
    width: $size;
    height: $size;
    flex-shrink: 0;
}
.divider {
    height: 2.5em;
    width: 1px;
    margin: 0.5em 1em;
    background-color: rgba(white, 0.05);
    align-self: flex-start;
}

.lifekeys {
    display: flex;
}
.lifekeysGap {
    width: 1em;
}
.Lifekey {
    position: relative;
    $size: 2.8em;
    width: $size;
    height: $size;
    flex-shrink: 0;

    &.completed {
        &::after {
            position: absolute;
            content: '';
            display: block;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            border: 1px solid #6feef6;
            border-radius: 50%;
            box-shadow: inset 0 0 3px 0px #6feef6;
        }
    }
}

.textContainer {
    margin-left: 2em;
}
.beltName {
    color: rgba(white, 0.9);
    font-weight: 600;
}
.beltName--noBelt {
    text-transform: none;
    font-style: italic;
    font-weight: normal;
    color: rgba(white, 0.5);
}
.beltGrade {
    text-transform: capitalize;
}
.nextBeltProgress {
    color: rgba(white, 0.5);
    margin-top: 0.3em;
}
.nextBeltProgressContainer {
    display: flex;
    align-items: center;
}

.spacer {
    flex: 1;
}

.leaderboardContainer {
}
.leaderboardLink {
    color: rgba(white, 0.9);
}
.yourRank {
    color: rgba(white, 0.5);
    margin-top: 0.3em;
}

@include media('<mobile') {
    .BeltSection {
        align-items: flex-start;
    }
    .nextBeltProgressContainer {
        display: block;
    }
    .textContainer {
        margin-left: 0;
        margin-top: 0.5em;
    }
    .beltName {
        display: none;
    }
    .nextBeltProgressContainer {
        flex: 1;
        overflow: hidden;
    }
}
</style>
